import {
  KitchenFittingCategory,
  KitchenFittingSubCategory,
} from "./kitchenFittingsTypes";

export const kitchenFittingCategories: KitchenFittingCategory[] = [
  {
    id: 1,
    name: "Kitchen Sinks & Basins",
    description:
      "Stainless steel and composite kitchen sinks with single and double bowl options for modern kitchen requirements.",
    keyCharacteristics: [
      "Food-grade stainless steel",
      "Deep bowl design",
      "Sound deadening pads",
      "Easy maintenance surface",
    ],
    commonMaterials: [
      "SS304 stainless steel",
      "Granite composite",
      "Quartz composite",
      "Ceramic basin options",
    ],
    primaryUse: [
      "Food preparation",
      "Dish washing",
      "Kitchen cleanup",
      "Vegetable washing",
      "Commercial kitchen use",
    ],
    image360: "/api/placeholder/800/600",
    images360: [
      "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1600585152220-90363fe7e115?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1571736772567-3aa763ff559a?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1574269269401-859094eee3a5?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1590736969955-71cc94901144?w=800&h=600&fit=crop",
    ],
    thumbnails: [
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
    ],
    finishOptions: [
      "Satin Finish",
      "Mirror Polish",
      "Brushed Steel",
      "Matte Black",
    ],
    warranty: "10 years on stainless steel, 5 years on fittings",
    specifications: {
      material: "SS304 stainless steel with sound deadening",
      sizes: ["24x18 inches", "32x21 inches", "36x22 inches"],
      finish: ["Satin Finish", "Mirror Polish", "Brushed Steel", "Matte Black"],
      functionality: "Single/double bowl with drainer options",
      installation: "Top mount, under mount, or flush mount",
      maintenance: "Daily cleaning with mild detergent",
    },
    useCases: [
      {
        location: "Modern Kitchen",
        recommendation: "Double bowl sink with integrated drainer",
        keyChecks: [
          "Counter space availability",
          "Plumbing configuration",
          "Installation method preference",
        ],
      },
      {
        location: "Compact Kitchen",
        recommendation: "Single bowl with maximum depth",
        keyChecks: [
          "Space optimization",
          "Functional requirements",
          "Storage integration",
        ],
      },
      {
        location: "Luxury Kitchen",
        recommendation: "Premium composite with premium faucet pairing",
        keyChecks: [
          "Material coordination",
          "Design aesthetic",
          "Professional installation",
        ],
      },
      {
        location: "Commercial Kitchen",
        recommendation: "Heavy-duty stainless steel with high capacity",
        keyChecks: [
          "Commercial usage requirements",
          "Drainage capacity",
          "Health code compliance",
        ],
      },
    ],
  },
  {
    id: 2,
    name: "Kitchen Faucets & Taps",
    description:
      "High-performance kitchen faucets with pull-out sprays, single lever controls, and modern designs for cooking convenience.",
    keyCharacteristics: [
      "Pull-out spray functionality",
      "Single lever operation",
      "360-degree swivel spout",
      "Ceramic cartridge technology",
    ],
    commonMaterials: [
      "Brass body construction",
      "Chrome plated finish",
      "Stainless steel components",
      "Rubber O-ring seals",
    ],
    primaryUse: [
      "Kitchen sink operation",
      "Food preparation",
      "Pot filling",
      "Cleaning tasks",
      "Bar sink applications",
    ],
    image360: "/api/placeholder/800/600",
    images360: [
      "https://images.unsplash.com/photo-1600585152220-90363fe7e115?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1571736772567-3aa763ff559a?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1574269269401-859094eee3a5?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1590736969955-71cc94901144?w=800&h=600&fit=crop",
    ],
    thumbnails: [
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
    ],
    finishOptions: ["Chrome", "Stainless Steel", "Matte Black", "Brushed Gold"],
    warranty: "5 years on cartridge, 2 years on finish",
    specifications: {
      material: "Brass body with premium plating",
      sizes: ["Standard height", "High-arc design", "Commercial style"],
      finish: ["Chrome", "Stainless Steel", "Matte Black", "Brushed Gold"],
      functionality: "Pull-out spray with multiple patterns",
      installation: "Single hole or 3-hole mounting",
      maintenance: "Regular cleaning and cartridge service",
    },
    useCases: [
      {
        location: "Home Kitchen",
        recommendation: "Pull-out spray faucet for versatile cooking needs",
        keyChecks: [
          "Sink compatibility",
          "Counter clearance",
          "Water pressure requirements",
        ],
      },
      {
        location: "Bar Area",
        recommendation: "Compact faucet with elegant design",
        keyChecks: [
          "Space constraints",
          "Design coordination",
          "Functionality requirements",
        ],
      },
      {
        location: "Commercial Kitchen",
        recommendation: "Heavy-duty commercial faucet with high flow",
        keyChecks: [
          "Commercial grade requirements",
          "Heavy usage capability",
          "Easy maintenance",
        ],
      },
      {
        location: "Island Kitchen",
        recommendation: "High-arc faucet for large pot accommodation",
        keyChecks: [
          "Height clearance",
          "360-degree functionality",
          "Installation complexity",
        ],
      },
    ],
  },
  // Add more categories as needed for brevity
];

export const kitchenFittingSubCategories: KitchenFittingSubCategory[] = [
  {
    id: 1,
    categoryId: 1,
    name: "Double Bowl SS Kitchen Sink",
    description: "Premium double bowl stainless steel sink with drainer",
    image: "/api/placeholder/300/200",
    features: [
      "Double bowl design",
      "Integrated drainer",
      "SS304 grade steel",
      "Sound deadening",
    ],
    image360: "/api/placeholder/800/600",
    price: "₹8,000 - ₹18,000",
    availability: "In Stock",
  },
  {
    id: 2,
    categoryId: 2,
    name: "Pull-Out Kitchen Faucet",
    description: "Modern pull-out spray kitchen faucet with ceramic cartridge",
    image: "/api/placeholder/300/200",
    features: [
      "Pull-out spray",
      "Single lever",
      "Chrome finish",
      "5-year warranty",
    ],
    image360: "/api/placeholder/800/600",
    price: "₹6,000 - ₹15,000",
    availability: "In Stock",
  },
];
